
export const loginIcon = () => {
   return (
      <svg
         id="login-svg"
         width="30" height="30" viewBox="0 0 30 30"
         xmlns="http://www.w3.org/2000/svg" 
      >
         <defs>
            <clipPath id="login-path">
               <rect
                  x="0" y="0" 
                  width="30" height="30"
                  fill="#dadee3" />
            </clipPath>
         </defs>
         <g transform="translate(10764.147,21991)">
            <g transform="translate(-10764.149,-21991)">
               <g clipPath="url(#login-path)">
               <path
                  d="M 13.149,0 A 13.149,13.149 0 1 0 26.3,13.149 13.164,13.164 0 0 0 13.149,0 m 0,1.879 a 11.251,11.251 0 0 1 8.951,18.094 8.9,8.9 0 0 0 -5.418,-5.257 5.636,5.636 0 1 0 -7.065,0 A 8.9,8.9 0 0 0 4.2,19.973 11.25,11.25 0 0 1 13.15,1.879 m -3.758,8.453 a 3.757,3.757 0 1 1 3.757,3.757 3.761,3.761 0 0 1 -3.757,-3.757 M 5.717,21.6 c 0.528,-3.22 3.693,-5.634 7.432,-5.634 3.739,0 6.9,2.413 7.432,5.634 a 11.205,11.205 0 0 1 -14.864,0"
                  fill="#dadee3" />
               </g>
            </g>
            <rect
               x="0" y="0"
               width="30" height="30"
               transform="translate(-10766,-21993)"
               fill="none" />
         </g>
      </svg>
   )
}

export const closeIcon = () => {
   return (
      <svg 
         width="14" height="19" viewBox="0 0 14 19" 
         fill="none" 
         xmlns="http://www.w3.org/2000/svg"
      >
         <path 
            d="M12.4906 5.58868C12.9464 5.12481 12.9464 4.37149 12.4906 3.90762C12.0349 3.44376 11.2948 3.44376 10.8391 3.90762L7 7.81895L3.15729 3.91133C2.70156 3.44747 1.96146 3.44747 1.50573 3.91133C1.05 4.3752 1.05 5.12852 1.50573 5.59239L5.34844 9.50001L1.50938 13.4113C1.05365 13.8752 1.05365 14.6285 1.50938 15.0924C1.9651 15.5563 2.70521 15.5563 3.16094 15.0924L7 11.1811L10.8427 15.0887C11.2984 15.5525 12.0385 15.5525 12.4943 15.0887C12.95 14.6248 12.95 13.8715 12.4943 13.4076L8.65156 9.50001L12.4906 5.58868Z" 
            fill="#0857C3" />
      </svg>
   )
}